import { render, staticRenderFns } from "./LibroLecturaPreschool.vue?vue&type=template&id=52f6fb23"
import script from "./LibroLecturaPreschool.vue?vue&type=script&lang=js"
export * from "./LibroLecturaPreschool.vue?vue&type=script&lang=js"
import style0 from "./LibroLecturaPreschool.vue?vue&type=style&index=0&id=52f6fb23&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports